import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';
import { Loader2, CheckCircle2, ArrowLeft, MessageCircle } from 'lucide-react';

const PublicLead = () => {
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({
    nome: '',
    telefone: '',
    observacoes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome.trim() || !form.telefone.trim()) {
      toast.error('Nome e telefone são obrigatórios');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post('/api/public/leads', form);
      setSuccess(true);
    } catch (err) {
      console.error('Erro ao enviar contato', err);
      toast.error('Erro ao enviar. Tente novamente.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardContent className="p-8 text-center space-y-4">
            <div className="mx-auto w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center">
              <CheckCircle2 size={40} className="text-emerald-600" />
            </div>
            <h1 className="text-2xl font-bold" style={{ fontFamily: 'Work Sans' }}>
              Recebemos seu contato!
            </h1>
            <p className="text-gray-600">
              Nossa equipe entrará em contato em breve para entender sua necessidade e enviar um orçamento personalizado.
            </p>
            <Link to="/">
              <Button variant="outline" className="mt-2" data-testid="voltar-site-btn">
                <ArrowLeft size={16} className="mr-2" /> Voltar ao site
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 py-10 px-4" data-testid="public-lead-page">
      <div className="max-w-lg mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-emerald-700 mb-6">
          <ArrowLeft size={16} /> Voltar ao site
        </Link>

        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-sm font-medium mb-3">
            <MessageCircle size={14} />
            Fale com a Tenance
          </div>
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Work Sans' }}>
            Deixe seu contato
          </h1>
          <p className="text-gray-600 mt-2">
            Preencha os campos abaixo e retornaremos em breve para agendar um orçamento sem compromisso.
          </p>
        </div>

        <Card>
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1">
                <Label htmlFor="nome" className="text-gray-700">Nome completo *</Label>
                <Input
                  id="nome"
                  value={form.nome}
                  onChange={(e) => setForm({ ...form, nome: e.target.value })}
                  required
                  placeholder="Seu nome"
                  data-testid="public-lead-nome-input"
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="telefone" className="text-gray-700">WhatsApp / Telefone *</Label>
                <Input
                  id="telefone"
                  value={form.telefone}
                  onChange={(e) => setForm({ ...form, telefone: e.target.value })}
                  required
                  placeholder="(31) 9 9999-9999"
                  data-testid="public-lead-telefone-input"
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="observacoes" className="text-gray-700">Como podemos te ajudar?</Label>
                <Textarea
                  id="observacoes"
                  value={form.observacoes}
                  onChange={(e) => setForm({ ...form, observacoes: e.target.value })}
                  rows={4}
                  placeholder="Ex.: preciso trocar o chuveiro e reparar uma torneira"
                  data-testid="public-lead-observacoes-input"
                />
              </div>

              <Button
                type="submit"
                disabled={submitting}
                className="w-full text-white"
                style={{ backgroundColor: '#2B7A3D' }}
                data-testid="public-lead-submit-btn"
              >
                {submitting ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  'Quero ser contatado'
                )}
              </Button>

              <p className="text-xs text-gray-500 text-center">
                Ao enviar, você concorda em ser contatado pela equipe da Tenance.
              </p>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PublicLead;
